/**
 * Configuracion de variables de entorno
 */

/**
 * Build the API base URL, ensuring the /api/v1 prefix is present exactly once.
 *
 * Why this exists: in production we deploy the backend under `/api/v1/*` and
 * the frontend under `/`. If the operator sets VITE_API_BASE_URL to the
 * backend root (e.g. `https://whatmix.streamix.uk`) and we use that verbatim,
 * every fetch ends up at `/auth/login` instead of `/api/v1/auth/login` and
 * the backend returns 405. Centralizing the suffix here means a misconfigured
 * base URL still produces a working client, and a correctly-suffixed one is
 * not duplicated.
 *
 * Dev behavior is unchanged: the Vite proxy strips `/api` and forwards to
 * `VITE_API_BASE_URL` (default http://localhost:3000).
 */
/**
 * Build the API base URL, ensuring the /api/v1 prefix is present exactly once.
 *
 * Exported (not unexported) so the unit test in env.test.ts can exercise the
 * branching directly with mocked import.meta.env values, instead of having to
 * rebuild the whole module.
 */
export function buildApiUrl(): string {
	// In dev, the proxy handles routing — /api/v1 is correct as-is.
	if (import.meta.env.DEV) return "/api/v1";

	// In prod, prefer the operator-supplied base URL. Empty / missing falls
	// back to "/api/v1" which works behind a same-origin reverse proxy.
	const base = import.meta.env.VITE_API_BASE_URL || "";
	const trimmed = base.replace(/\/+$/, "");

	// Already has /api/v1? Keep it. Anything else: append.
	// Guards against operators who already include /api/v1 (no duplication)
	// and against those who don't (we add it).
	return trimmed.endsWith("/api/v1") ? trimmed : `${trimmed}/api/v1`;
}

export const env = {
	API_URL: buildApiUrl(),
	API_KEY: import.meta.env.VITE_API_KEY || "",
	APP_NAME: import.meta.env.VITE_APP_NAME || "Whatmix",
	IS_DEV: import.meta.env.DEV,
	IS_PROD: import.meta.env.PROD,
} as const;

if (env.IS_PROD && !import.meta.env.VITE_API_BASE_URL) {
	console.warn(
		"VITE_API_BASE_URL no esta definida en el entorno de produccion.",
	);
}
